import CreateReferenciasEnlaceC3 from '@/modules/referencias/application/CreateReferenciasEnlaceC3'
import DeleteReferenciaEnlaceC3 from '@/modules/referencias/application/DeleteReferenciaEnlaceC3'
import GetReferenciaById from '@/modules/referencias/application/GetReferenciaById'
import UpdateReferenciasEnlaceC3 from '@/modules/referencias/application/UpdateReferenciasEnlace'
import UpdateVigenciaReferencia from '@/modules/referencias/application/UpdateVigenciaReferencia'
import ReferenciaEnlaceC3ApiRepository from '@/modules/referencias/infrastructure/ReferenciaEnlaceApiRepository'
import ReferenciaEntity from '@/modules/referencias/domain/ReferenciaEntity'
import { TIPO_REFERENCIAS, TIPO_REFERENCIAS_LABORALES } from '@/modules/referencias/domain/TIPO_REFERENCIAS'

export default {
  namespaced: true,
  state: {
    referencias: [],
    selectedReferencia: null,
  },
  getters: {
    getReferenciaVecinal: (state) =>
      state.referencias.filter(({ tipo, vigente }) => tipo === TIPO_REFERENCIAS.VECINAL && vigente === true),
    getReferenciasLaborales: (state) =>
      state.referencias.filter(({ tipo, vigente }) => TIPO_REFERENCIAS_LABORALES.includes(tipo) && vigente === true),
    getReferenciasPersonales: (state) =>
      state.referencias.filter(({ tipo, vigente }) => tipo === TIPO_REFERENCIAS.PERSONAL && vigente === true),
  },
  mutations: {
    SET_REFERENCIAS(state, referencias) {
      state.referencias = referencias
    },
    SET_SELECTED_REFERENCIA(state, referencia) {
      state.selectedReferencia = { ...referencia }
    },
    CLEAR_REFERENCIAS(state) {
      state.referencias = []
    },
    CLEAR_SELECTED_REFERENCIA(state) {
      state.selectedReferencia = null
    },
  },
  actions: {
    async fetchReferenciasByPersonal({ commit }, idPersonal) {
      const referencias = await new ReferenciaEnlaceC3ApiRepository().getById(idPersonal)
      const referenciasEntities = referencias.map((referenciaDto) => new ReferenciaEntity().fromDto(referenciaDto))

      commit('SET_REFERENCIAS', referenciasEntities)
    },

    async fetchReferenciaById({ commit }, { idPersonal, idReferencia }) {
      const referencia = await new GetReferenciaById(new ReferenciaEnlaceC3ApiRepository()).execute(
        idPersonal,
        idReferencia
      )
      commit('SET_SELECTED_REFERENCIA', referencia)
    },

    async createReferencia({ dispatch }, { idPersonal, referencia }) {
      await new CreateReferenciasEnlaceC3(new ReferenciaEnlaceC3ApiRepository()).execute(idPersonal, referencia)
      await dispatch('fetchReferenciasByPersonal', idPersonal)
    },

    async updateReferencia({ dispatch }, { idPersonal, referencia }) {
      await new UpdateReferenciasEnlaceC3(new ReferenciaEnlaceC3ApiRepository()).execute(idPersonal, referencia)
      dispatch('fetchReferenciasByPersonal', idPersonal)
    },

    async deleteReferencia({ dispatch }, { idPersonal, idReferencia }) {
      await new DeleteReferenciaEnlaceC3(new ReferenciaEnlaceC3ApiRepository()).execute(idPersonal, idReferencia)
      await dispatch('fetchReferenciasByPersonal', idPersonal)
    },

    async setVigenciaReferencia({ commit }, { idPersonal, idReferencia }) {
      const result = await new UpdateVigenciaReferencia(new ReferenciaEnlaceC3ApiRepository()).execute(
        idPersonal,
        idReferencia
      )
      commit('SET_SELECTED_REFERENCIA', result)
    },

    clearReferencias({ commit }) {
      commit('CLEAR_REFERENCIAS')
    },

    clearSelectedReferencia({ commit }) {
      commit('CLEAR_SELECTED_REFERENCIA')
    },
  },
}
